<template>
    <div id="game" class="game futura row">
        <template v-if="layoutProfile && layoutProfile.layout == 5">
            NEW 2022
        </template>
        <template v-else>
            <div class="col-12" v-if="gm.inGamePlayerCheck(logged_in_user)">
                <a href="/matchrequests" class="btn btn-danger btn-lg btn-block">{{__("games.end_watch")}}</a>
            </div>
            <template v-if="gm.players">
                <template v-if="gm.players.length <= 2">
                    <game-asset-score-player :player_name="player.name" :player_id="player.id" :active_player="gm.isActivePlayer(player.id)" :score_player="player.score" :sets_player="player.sets" :legs_player="player.legs" :throw_player="player.throw" :singlescore_player="JSON.stringify(player.singlescores)" :calculated_score="calculatedScore(player.id)" :gm="gm" :dartcounter="dartcounter" :cputimer="player.cpu_time" v-for="player, idx in gm.players" :key="idx" />
                </template>
                <template v-else>
                    <game-asset-scores-small :players="gm.players" :current="gm.currentPlayer"></game-asset-scores-small>
                    <game-asset-score-player :player_name="gm.currentPlayer.name" :player_id="gm.currentPlayer.id" :active_player="gm.isActivePlayer(gm.currentPlayer.id)" :score_player="gm.currentPlayer.score" :sets_player="gm.currentPlayer.sets" :legs_player="gm.currentPlayer.legs" :throw_player="gm.currentPlayer.throw" :singlescore_player="JSON.stringify(gm.currentPlayer.singlescores)" :calculated_score="calculatedScore(gm.currentPlayer.id)" :cputimer="gm.currentPlayer.cpu_time" :gm="gm" :dartcounter="dartcounter" />
                </template>
            </template>

            <div class="subnav" v-if="layoutProfile && (layoutProfile.show_history || layoutProfile.show_numpad)">
                <a href="#" v-if="layoutProfile &&layoutProfile.show_numpad" :class="['item', showmenu == 'numpad' ? 'active' : 'inactive']" @click="showSubMenu('numpad')"><i class="fas fa-th"></i> {{__("games.input")}} <a href="#" class="numpad-helper" @click="$refs.numpad.toggleHelper()"><i class="far fa-question-circle"></i></a></a>
                <a href="#" v-if="layoutProfile &&layoutProfile.show_history" :class="['item', showmenu == 'history' ? 'active' : 'inactive']" @click="showSubMenu('history')"><i class="fas fa-list-ol"></i> {{__('games.history')}}</a>
            </div>

            <div class="flexrow" v-if="layoutProfile">
                <div class="numpad shadow-inactive" v-if="showmenu =='numpad' && layoutProfile.show_numpad">
                    <numpad :disabledInput='disabledInput' @add="add" @clr="clr" @send="send" @check="check" @rest="rest" :allowCheck="allowCheckCheck()" ref="numpad"></numpad>
                </div>
                <numpad hidden="true" :disabledInput='disabledInput' @add="add" @clr="clr" @send="send" @check="check" @rest="rest" :allowCheck="allowCheckCheck()" ref="numpad" v-if="!layoutProfile.show_numpad || showmenu != 'numpad'"></numpad>
                <div class="history shadow-inactive" v-if="showmenu =='history' && layoutProfile.show_history">
                    <game-asset-game-history :content="content" :headers="historyHeaders" :players="gm.players" />
                </div>
            </div>
        </template>

        <b-modal id="modal-leg-end" title="Leg beendet" @hidden="nextLeg">
            <div class="results">
                <game-asset-score-player :player_name="player.name" :player_id="player.id" :active_player="gm.isActivePlayer(player.id)" :score_player="player.score" :sets_player="player.sets" :legs_player="player.legs" :throw_player="player.throw" :singlescore_player="JSON.stringify(player.singlescores)" :calculated_score="calculatedScore(player.id)" :gm="gm" :dartcounter="dartcounter" :winner="winner ? winner.name : ''" v-for="player, idx in gm.players" :key="idx" />
            </div>
            <div class="history shadow-light mt-3">
                <game-asset-game-history :content="content" :headers="historyHeaders" :players="gm.players" />
            </div>
            <template #modal-footer>
                <game-asset-next-leg @nextleg="$bvModal.hide('modal-leg-end')"></game-asset-next-leg>
            </template>
        </b-modal>
        <game-asset-determine-start-player :startDetermineStartPlayer="startingPlayerDetermined" :firstleg="gm.firstleg" :game="game" @activePlayer="setStartingPlayer" :gameState="gm.gameState" :players="gm.players"></game-asset-determine-start-player>
        <game-asset-video-player :throwPoints="gm.lastscore"></game-asset-video-player>
        <game-asset-game-results :game="game" :playersProp="gm.players" :gm="gm" :showResults="showResults"></game-asset-game-results>
    </div>
</template>

<script>

import numpad from './gameAssets/gameAssetNumpad.vue';
import GameAssetScorePlayer from './gameAssets/gameAssetScorePlayer.vue';
import GameAssetGameHistory from './gameAssets/gameAssetGameHistory.vue';
import GameAssetDetermineStartPlayer from './gameAssets/gameAssetDetermineStartPlayer.vue';
import GameAssetVideoPlayer from './gameAssets/gameAssetVideoPlayer.vue';
import AudioPlayer from './gameAssets/gameAssetAudioPlayer.js';
import GameAssetStatistics from './gameAssets/gameAssetStatisticsSmall.vue';
import GameAssetGameResults from './gameAssets/gameAssetGameResults.vue';

import GameManger from './gameAssets/gameManager';
import moment from 'moment';
import GameAssetScoresSmall from './gameAssets/gameAssetScoresSmall.vue';

export default {
    components: {
        numpad,
        GameAssetScorePlayer,
        GameAssetGameHistory,
        GameAssetDetermineStartPlayer,
        GameAssetVideoPlayer,
        GameAssetStatistics,
        GameAssetGameResults,
        GameAssetScoresSmall
    },
    props: ['game_prop', 'players_prop', 'player1_prop', 'player2_prop', 'logged_in_user', 'logged_in_player', 'cpu_prop'],
    mixins: [AudioPlayer],
    data() {
        return {
            gm: null,
            throw: 0,
            dartcounter: 0,
            throwPoints: 0,
            game: this.game_prop,
            content: {},
            winner: null,
            disabledInput: true,
            watchstarted: false,
            startingPlayerDetermined: false,
            outOption: "Double Out",
            inOption: "Single In",
            layoutProfile: null,
            showmenu: 'numpad',
            showResults: false,
            cputimer: null,
            webcamToggle: false,
            cpu: this.cpu_prop,
            historyHeaders: [
                { name: __("games.thrown"), value: "singlescores" },
                { name: __("games.throw"), value: "roundscore" },
                { name: __("games.points"), main: true, value: "score" },
            ]
        }
    },
    created() {
        // create game manager object and read options
        this.gm = new GameManger(this);
        this.gm.start();
    },
    mounted() {
        if (this.game.status == "completed") {
            //do not parse the game when it is completed
            //the game show results component will do this
            return;
        }
        //TODO: Add better layout profile defaults
        this.layoutProfile = window.currentProfile ? window.currentProfile : { layout: 1, show_history: true, show_numpad: true };
        if (!this.layoutProfile.show_numpad && this.layoutProfile.show_history) this.showmenu = 'history';
        if (this.layoutProfile.webcamDisplayOption == "webcamDisplayActivePlayer") this.webcamToggle = true;

        this.$root.$emit('ProfileSelectorAddObserver', this.loadProfile)
        if (this.gm.debugger) console.log("players: ", this.gm.players)
    },
    methods: {
        loadProfile(profile) {
            this.layoutProfile = profile;
            if (this.layoutProfile.webcamDisplayOption == "webcamDisplayActivePlayer") this.webcamToggle = true;
        },
        createUIElements() {
            return new Promise((resolve, reject) => {
                resolve();
            })
        },
        setPlayerOptions() {
            return new Promise((resolve, reject) => {
                this.gm.players.forEach(player => {
                    player.start = this.gm.gameoptions.Start;
                    player.score = parseInt(player.start)
                    player.throw = 0;
                    player.singlescores = [];
                });
                this.outOption = this.gm.gameoptions.Out;
                this.inOption = this.gm.gameoptions.In;
                this.clr();
                resolve();
            });
        },
        setStartingPlayer(id) {
            if (this.gm.debugger) console.log("setting startting player to: " + id)
            this.startDetermineStartPlayer = false;
            this.gm.setActivePlayer(id, true);
            this.gm.setNextState();
        },

        prepareActivePlayer() {
            return new Promise((resolve, reject) => {
                this.gm.getActivePlayer().throw = 0;
                this.gm.getActivePlayer().singlescores = [];
                this.clr();
                this.$root.$emit("gamePlayerChange", this.gm.getActivePlayer());
                setTimeout(e => {
                    this.throwPoints = -1; //reset throw points for videoplayer
                })
                resolve();
            })
        },
        winCheck() {
            return new Promise((resolve, reject) => {
                var winner = false;
                this.gm.players.forEach(player => {
                    if (player.score == 0) {
                        winner = true;
                    }
                });
                resolve({ winner: winner });
            })
        },
        winCheckSingle() {
            return new Promise((resolve, reject) => {
                var winner = false;
                if (this.winCheckOutOptions()) {
                    this.send();
                    winner = true;
                }
                resolve({ winner: winner });
            })
        },
        singleScoreBust() {
            toastError("Ueberworfen");
            this.throw = 0;
            //mark the last dart as missed
            this.gm.getActivePlayer().singlescores[this.gm.getActivePlayer().singlescores.length - 1].missed = true;
            if (this.dartcounter < 3) {
                axios.post("/games/singlescore", { dart: 0, times: 3 - this.dartcounter });
            }
            this.gm.finishRound();
        },

        winCheckOutOptions() {
            var player = this.gm.getActivePlayer();
            var score = player.score;
            var multiplier = player.singlescores[player.singlescores.length - 1].multiplier;
            var result = score - this.throw;
            //check < 0 first
            if (result < 0) this.singleScoreBust();
            //single out check
            if (this.outOption == "Single Out" && result == 0) {
                return true;
            }
            //double out check
            if (this.outOption == "Double Out" && result == 0 && multiplier == 2) {
                return true;
            } else if (this.outOption == "Double Out" && ((result == 0 && multiplier != 2) || (result == 1))) {
                this.singleScoreBust();
            }
            //double out + master out 1 rest = ueberworfen
            if (this.outOption == "Double Out" && result == 1) this.singleScoreBust();
            if (this.outOption == "Master Out" && result == 1) this.singleScoreBust();

            //master out check
            if (this.outOption == "Master Out" && result == 0 && multiplier != 1) {
                return true;
            } else if (this.outOption == "Master Out" && result == 0 && multiplier == 1) {
                return false;
            }
            return false;
        },
        add(number) {
            if (this.gm.getActivePlayer().singlescores.length > 0) return; //do not allow adding numbers when single darts were thrown
            if (this.throw + number > 180) return; //dont allow to add more than 180 to your throw
            if (this.gm.getActivePlayer().throw == 0) this.gm.getActivePlayer().throw = "";
            this.gm.getActivePlayer().throw += number;
            this.throw = this.gm.getActivePlayer().throw;
        },
        rest() {
            if (this.throw < this.gm.getActivePlayer().score) {
                this.throw = this.gm.getActivePlayer().score - this.throw;
                this.send();
            }
        },
        clr() {
            this.gm.getActivePlayer().throw = 0;
            this.gm.getActivePlayer().singlescores = [];
            this.throw = 0;
            this.gm.resetRound();
        },
        check(number) {
            this.throw = this.gm.getActivePlayer().score;
            if (number == 0) {
                this.throw = 0;
            }
            this.send();
        },
        send() {
            if (this.checkValidThrow() && !this.disabledInput) {
                this.disabledInput = true;
                axios.post("/api/games/" + this.game.id + "/sendfullscore", { player: this.gm.getActivePlayer().id, score: this.throw, singlescores: this.gm.getActivePlayer().singlescores }).then(() => {
                    if (this.gm.debugger) console.log("Waiting for Input complete")
                    this.throwPoints = this.throw;
                    setTimeout(() => {
                        this.gm.setNextState();
                    }, 250);
                })
            } else {
                console.log("Error: Non Valid throw");
            }
        },
        finishRoundOrSend() {
            if (this.checkValidThrow() && !this.disabledInput) {
                if (this.gm.getActivePlayer().singlescores.length > 0 && this.gm.getActivePlayer().singlescores.length < 3) {
                    //add zeros to the remaining darts
                    if (this.dartcounter < 3) {
                        axios.post("/games/singlescore", { dart: 0, times: 3 - this.dartcounter });
                    }
                    this.gm.finishRound();
                } else {
                    this.send();
                }
            }
        },
        checkValidThrow() {
            //dont allow return above 180
            //console.log(this.active_player + " wants to send a score: " + this.throw);
            if (this.throw > 180) {
                toastError("Fehlerhafter Wert, kann nicht größer als 180 sein");
                return false;
            }
            if (this.gm.getActivePlayer().score - this.throw < 0) {
                toastError("Fehlerhafter Wert, Ergebnis wäre kleiner 0");
                return false;
            }
            if (this.gm.getActivePlayer().score - this.throw == 1 && this.outOption != "Single Out") {
                //Ueberworfen
                toastError("Ueberworfen");
                this.throw = 0
            }
            if (this.logged_in_user != this.gm.getActivePlayer().user_id && !this.gm.getActivePlayer().guest) {
                return false;
            }

            if (this.gm.getActivePlayer().score - this.throw == 0 && this.gm.getActivePlayer().singlescores.length > 0 && !this.winCheckOutOptions()) {
                //player did not hit the correct out option
                this.throw = 0;
            }
            return true;
        },
        parseContent() {
            //parses the content of the leg to show what happens in this game
            if (!this.content || !this.content.start) return;
            var last_active_player_id = 0;
            var last_score = 0;
            var last_score_singles = false;
            this.gm.players.forEach(player => {
                player.score = this.content.start;
            });
            this.content.throws.forEach(t => {
                this.gm.players.forEach(player => {
                    if (t.player == player.id) {
                        player.score -= parseInt(t.fullscore);
                        player.throw = t.fullscore;
                        last_active_player_id = player.id;
                        last_score = player.throw;
                        last_score_singles = t.singlescores && t.singlescores.length > 0;
                    }
                });
            });
            return { lastplayer: last_active_player_id, lastscore: last_score, lastscoresingles: last_score_singles };
        },
        showWinner() {
            this.gm.players.forEach(player => {
                if (player.score == 0) {
                    this.winner = player;
                }
            });
            if (this.winner != null) {
                this.showResults = true;
            }
        },
        backToMatchmaking() {
            window.location.href = "/matchrequests/";
        },
        inCheck(dart) {
            if (this.throw > 0 || this.gm.getActivePlayer().score != this.gm.getActivePlayer().start) return true;
            if (this.inOption == "Single In") return true;
            if ((this.inOption == "Double In" || this.inOption == "Master In") && dart.multiplier == 2) return true;
            if (this.inOption == "Master In" && dart.multiplier == 3) return true;
            return false;
        },
        parseSingleScore(activeplayer, dart) {
            if (!this.inCheck(dart)) {
                dart.missed = true;
                dart.value = 0;
            }
            //mark as missed if dart value is 0
            if (dart.value == 0) dart.missed = true;
            if (activeplayer.singlescores.length < 3) {
                activeplayer.throw = 0;
                this.throw = 0;
                this.dartcounter = 0;
                activeplayer.singlescores.push(dart);
                activeplayer.singlescores.forEach(score => {
                    activeplayer.throw += score.value;
                    this.throw += score.value;
                    this.dartcounter += 1;
                });
                if (this.dartcounter == 3) {
                    this.gm.finishRound(this.throw);
                }

                if (dart.missed) this.playAudioFile("miss");
                if (dart.base == 25 && dart.multiplier == 2) this.playAudioFile("dbull");
                if (dart.base == 20 && dart.multiplier == 3) this.playAudioTripple(20);
                if (dart.base == 19 && dart.multiplier == 3) this.playAudioTripple(19);
                if (dart.base == 18 && dart.multiplier == 3) this.playAudioTripple(18);
                if (dart.base == 17 && dart.multiplier == 3) this.playAudioTripple(17);
            }
            console.log("vuejs update", moment().format('HH:mm:ss:SSS'))
        },
        showNextLeg() {
            this.gm.players.forEach(player => {
                if (player.score == 0) {
                    this.winner = player;
                }
            });
            this.$bvModal.show('modal-leg-end');
        },
        nextLeg() {
            toastSuccess("Starte naechstes Leg");
            this.gm.startNextLeg()
            this.$bvModal.hide('modal-leg-end');
            this.dartcounter += 1;
            //location.reload();
        },
        allowCheckCheck() {
            if (!this.gm.getActivePlayer()) return false;
            var returnValue = false;
            if (this.gm.getActivePlayer().score <= 180) return true;
            return returnValue;
        },
        calculatedScore(player_id) {
            if (this.gm.getActivePlayer().id == player_id && this.gm.getActivePlayer().score != 0) {
                return this.gm.getActivePlayer().score - this.throw;
            }
        },

        showSubMenu(name) {
            this.showmenu = name;
        }
    }
}
</script>

<style scoped>
</style>
